import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import {
  Typography
} from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';
import PersonIcon from '@mui/icons-material/Person';

import { numberWithCommas } from '../../../helpers'
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    height: '100%'
  },
  chartContainer: {
    position: 'relative',
    height: '300px'
  },
  stats: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  source: {
    textAlign: 'center',
    padding: theme.spacing(1)
  },
  sourceIcon: {
    color: theme.palette.icon
  }
});

const Chart = props => {
  const { data } = props;
  
  const classes = useClasses(styles);
  const theme = useTheme();

  const chart_data = {
    datasets: [
      {
        data: [data.total_suspicious_activity_hits, data.total_slow_pay_hits, data.total_split_pay_hits, data.total_stacking_history_hits, data.total_criminal_history_hits, data.total_covid_hardship_hits, data.total_default_hits, data.total_other_hits, data.total_default_satisfied_hits],
        backgroundColor: [
          theme.palette.suspicious_activity.main,
          theme.palette.slow_pay.main,
          theme.palette.split_payer.main,
          theme.palette.stacking_history.main,
          theme.palette.criminal_history.main,
          theme.palette.covid_hardship.main,
          theme.palette.default_account.main,
          theme.palette.other.main,
          theme.palette.stacking_history.main,
          theme.palette.default_satisfied.main
        ],
        borderColor: '#fff',
        hoverBorderColor: '#fff'
      }
    ],
    labels: data.labels
  };

  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: theme.palette.divider,
      backgroundColor: '#fff',
      titleFontColor: theme.palette.text.primary,
      bodyFontColor: theme.palette.text.secondary,
      footerFontColor: theme.palette.text.secondary
    }
  };

  const sources = [
    {
      title: 'Suspicious Activity',
      value: `${data.percent_suspicious_activity_hits}%`,
      icon: <ComputerIcon />,
      color: theme.palette.suspicious_activity.main,
    },
    {
      title: 'Slow Pay',
      value: `${data.percent_slow_pay_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.slow_pay.main
    },
    {
      title: 'Split Payer',
      value: `${data.percent_split_pay_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.split_payer.main
    },
    {
      title: 'Stacking History',
      value: `${data.percent_stacking_history_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.stacking_history.main
    },
    {
      title: 'Criminal History',
      value: `${data.percent_criminal_history_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.criminal_history.main
    },
    {
      title: 'Covid-19 Hardship',
      value: `${data.percent_covid_hardship_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.covid_hardship.main
    },
    {
      title: 'Default',
      value: `${data.percent_default_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.default_account.main
    },
    {
      title: 'Other',
      value: `${data.percent_other_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.other.main
    },
    {
      title: 'Default Satisfied',
      value: `${data.percent_default_satisfied_hits}%`,
      icon: <PersonIcon />,
      color: theme.palette.default_satisfied.main
    }
  ];

  return (
    <div>
      <div className={classes.chartContainer}>
        <Doughnut
          data={chart_data}
          options={options}
        />
      </div>
      <div className={classes.stats}>
        {sources.map(source => (
          <div
            className={classes.source}
            key={source.title}
          >
            <Typography variant="body1">{source.title}</Typography>
            <Typography
              style={{ color: source.color }}
              variant="h2"
            >
              {source.value}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Chart;
